// Häckkalkylator (simple + variable) — tier-medveten (volymrabatt).
document.addEventListener('DOMContentLoaded', function () {
    const calc = document.querySelector('.hedge-calculator')
    if (!calc) return

    const metersInput = calc.querySelector('#hedge-meters')
    const qtyInput2 = calc.querySelector('#hedge-qty')
    const pricePerMeterDisplay = calc.querySelector('[data-hedge-price-per-meter]')
    const pricePerMeterSummary = document.querySelector('[data-hedge-price-per-meter-summary]')
    const totalPriceDisplay = calc.querySelector('[data-hedge-total-price]')
    const priceArea = calc.querySelector('[data-hedge-price-area]')
    const minQtyValue = document.querySelector('[data-hedge-min-qty-value]')
    const belowMinWarning = calc.querySelector('[data-hedge-below-min-warning]')
    const form = calc.closest('.entry-summary')?.querySelector('form.cart')
    const qtyInput = form?.querySelector('input[name="quantity"]')
    const single_add_to_cart_button = form?.querySelector('.single_add_to_cart_button')

    const variationsRaw = calc.dataset.variations
    const variations = variationsRaw ? JSON.parse(variationsRaw) : null

    // parseFloat, inte parseInt: plantor per meter får vara decimaltal (t.ex. 2.5).
    // Attributet skrivs alltid med punkt av lw_plants_per_meter_attr().
    let plantsPerMeter = parseFloat(calc.dataset.plantsPerMeter)
    let minQuantity = parseInt(calc.dataset.minQuantity, 10)
    let activePrice = parseFloat(calc.dataset.activePrice)
    let regularPrice = parseFloat(calc.dataset.regularPrice) || activePrice
    let salePrice = calc.dataset.salePrice ? parseFloat(calc.dataset.salePrice) : null
    let currentTiers = readInitialTiers()

    // Produktens enhet ("st" som standard, t.ex. "m3"). Produkt-global — byts
    // aldrig vid variantbyte. Renderas server-side i lw_single_product_hedge_calculator.php.
    const unit = calc.dataset.unit || 'st'

    if (qtyInput) {
        qtyInput.readOnly = true
        qtyInput.tabIndex = -1
        qtyInput.closest('.quantity')?.classList.add('hidden')
    }
    if (single_add_to_cart_button) {
        single_add_to_cart_button.classList.add('md:col-span-full!', 'col-span-2!')
    }

    function escapeHtml(s) {
        const div = document.createElement('div')
        div.textContent = String(s)
        return div.innerHTML
    }

    function formatNumber(n) {
        return Math.round(n).toLocaleString('sv-SE')
    }

    function formatDecimal(n) {
        return String(Math.round(n * 100) / 100)
    }

    function readInitialTiers() {
        // För variabla produkter: använd default-variantens tiers (sätts senare av updateHedgeCalculator).
        // För simpla: läs från data-pricing-tiers på containern.
        if (variations && calc.dataset.hedgeInitialVariationId) {
            const id = parseInt(calc.dataset.hedgeInitialVariationId, 10)
            if (variations[id] && Array.isArray(variations[id].pricingTiers)) {
                return variations[id].pricingTiers
            }
            return []
        }
        try {
            const parsed = calc.dataset.pricingTiers ? JSON.parse(calc.dataset.pricingTiers) : []
            return Array.isArray(parsed) ? parsed : []
        } catch (e) {
            return []
        }
    }

    /**
     * Returnerar effektivt pris-per-styck för en given kvantitet.
     * Om en pristrappa matchar returneras tier-priset, annars activePrice (= reapris om satt, annars baspris).
     */
    function effectivePrice(qty) {
        if (!Array.isArray(currentTiers) || currentTiers.length === 0) return activePrice
        for (let i = 0; i < currentTiers.length; i++) {
            const t = currentTiers[i]
            const min = parseInt(t.min, 10)
            const max = t.max && t.max > 0 ? parseInt(t.max, 10) : Infinity
            if (qty >= min && qty <= max) return parseFloat(t.price)
        }
        return activePrice
    }

    let hedgeCurrentVariationId = null
    if (variations && calc.dataset.hedgeInitialVariationId) {
        hedgeCurrentVariationId = parseInt(calc.dataset.hedgeInitialVariationId, 10)
    }

    function sanitizeHedgeHeightDisplay(s) {
        if (s == null || s === '') return ''
        return String(s)
            .replace(/[\u2013\u2014\u2212]/g, '-')
            .replace(/[^\d-]/g, '')
            .replace(/-+/g, '-')
            .replace(/^-+|-+$/g, '')
    }

    function updateHedgeStickySummary() {
        const heightEl = document.querySelector('[data-hedge-height-show]')
        const metersEl = document.querySelector('[data-hedge-meters-show]')
        const qtyEl = document.querySelector('[data-hedge-qty-show]')
        const stickyTotalEl = document.querySelector('[data-hedge-sticky-total-price]')
        const stickyMinEl = document.querySelector('[data-hedge-sticky-min-qty]')

        if (metersEl) {
            metersEl.textContent = metersInput.value
        }
        if (qtyEl) {
            qtyEl.textContent = qtyInput2.value
        }

        if (stickyTotalEl) {
            const qty = parseInt(qtyInput2.value, 10) || 0
            const eff = effectivePrice(qty)
            const tierApplies = eff !== activePrice
            stickyTotalEl.textContent = formatNumber(eff * qty) + ' kr'
        }
        if (stickyMinEl) {
            const label = stickyMinEl.dataset.hedgeStickyMinQtyLabel
            stickyMinEl.textContent = label
                ? label + ' ' + minQuantity + ' ' + unit
                : String(minQuantity) + ' ' + unit
        }

        if (!heightEl) return

        if (variations && hedgeCurrentVariationId && variations[hedgeCurrentVariationId]) {
            const h = variations[hedgeCurrentVariationId].heightShow
            heightEl.textContent = sanitizeHedgeHeightDisplay(h)
            return
        }
        heightEl.textContent = sanitizeHedgeHeightDisplay(calc.dataset.hedgeHeightInitial)
    }

    /**
     * Uppdaterar pris-per-styck-displayen ("à X kr/st") baserat på aktuell kvantitet.
     * Visar tier-pris bold + ordinarie pris linje-igenom när tier matchar.
     */
    function updatePriceDisplay(qty) {
        if (!priceArea) return
        const eff = effectivePrice(qty)
        const tierApplies = eff !== activePrice
        // priceArea skrivs via innerHTML — enheten är fritext från admin och escapas.
        const perPiece = ' kr /' + escapeHtml(unit)
        const a = 'à '

        if (tierApplies) {
            priceArea.innerHTML =
                '<span class="font-bold text-sale-price" data-hedge-price-display>' +
                a +
                formatNumber(eff) +
                perPiece +
                '</span>' +
                '<span class="text-sm font-normal text-secondary-400 line-through" data-hedge-regular-price-display>' +
                formatNumber(regularPrice) +
                perPiece +
                '</span>'
            return
        }

        if (salePrice !== null && salePrice < regularPrice) {
            priceArea.innerHTML =
                '<span class="font-bold text-sale-price" data-hedge-price-display>' +
                a +
                formatNumber(salePrice) +
                perPiece +
                '</span>' +
                '<span class="text-sm font-normal text-secondary-400 line-through" data-hedge-regular-price-display>' +
                formatNumber(regularPrice) +
                perPiece +
                '</span>'
            return
        }

        priceArea.innerHTML =
            '<span class="font-bold text-secondary-900" data-hedge-price-display>' +
            a +
            formatNumber(activePrice) +
            perPiece +
            '</span>'
    }

    function updateBelowMinWarning(qty) {
        if (!belowMinWarning) return
        const below = qty > 0 && qty < minQuantity
        const minQtyValueEl = belowMinWarning.querySelector('.min-qty-value')
        belowMinWarning.classList.toggle('hidden', !below)
        if (below && minQtyValueEl) {
            minQtyValueEl.textContent = minQuantity
        }
    }

    function syncDisplay(qty) {
        if (qtyInput) {
            qtyInput.value = qty
            qtyInput.dispatchEvent(new Event('change', { bubbles: true }))
        }

        const eff = effectivePrice(qty)
        const tierApplies = eff !== activePrice
        const ppm = eff * plantsPerMeter

        pricePerMeterDisplay.textContent = '(' + formatNumber(ppm) + ' kr/meter)'
        if (pricePerMeterSummary) {
            pricePerMeterSummary.textContent = '(' + formatNumber(ppm) + ' kr/meter)'
        }

        if (totalPriceDisplay) {
            totalPriceDisplay.textContent = formatNumber(eff * qty) + ' kr'
        }

        updatePriceDisplay(qty)
        updateHedgeStickySummary()
        updateBelowMinWarning(qty)
    }

    // Meter → qty: live uppdatering utan min-clamp
    function onMetersInput() {
        const meters = parseFloat(metersInput.value)
        if (isNaN(meters) || meters <= 0) return

        const qty = Math.round(meters * plantsPerMeter)
        if (qtyInput2) qtyInput2.value = qty
        syncDisplay(qty)
    }

    // Meter → qty: clampa endast bort ogiltiga värden (NaN / ≤ 0), inte mot rekommenderat minimum.
    function onMetersCommit() {
        let meters = parseFloat(metersInput.value)
        if (isNaN(meters) || meters <= 0) {
            meters = 1 / plantsPerMeter
            metersInput.value = formatDecimal(meters)
        }

        const qty = Math.max(1, Math.round(meters * plantsPerMeter))
        if (qtyInput2) qtyInput2.value = qty
        syncDisplay(qty)
    }

    // Qty → meter: live uppdatering utan min-clamp
    function onQtyInput() {
        const qty = parseInt(qtyInput2.value, 10)
        if (isNaN(qty) || qty <= 0) return

        metersInput.value = formatDecimal(qty / plantsPerMeter)
        syncDisplay(qty)
    }

    // Qty → meter: clampa endast bort ogiltiga värden (NaN / < 1), inte mot rekommenderat minimum.
    function onQtyCommit() {
        let qty = parseInt(qtyInput2.value, 10)
        if (isNaN(qty) || qty < 1) {
            qty = 1
            qtyInput2.value = qty
        }

        metersInput.value = formatDecimal(qty / plantsPerMeter)
        syncDisplay(qty)
    }

    window.updateHedgeCalculator = function (variationId) {
        if (!variations) return
        const v = variations[variationId]
        if (!v) return

        // Variantbyte kan trigga updateHedgeCalculator två gånger (egen knapp + WC:s
        // found_variation). Om vi redan kört för denna variant, hoppa över — annars
        // hinner andra körningen läsa just satta värden och resetta felaktigt.
        const nextId = parseInt(variationId, 10)
        if (hedgeCurrentVariationId === nextId) return

        // Läs av nuvarande meter INNAN vi byter variant — vid variantbyte är det
        // användarens "jag vill plantera X meter häck" som ska behållas; antalet
        // plantor räknas om från nya variantens plants-per-meter.
        const previousMeters = metersInput ? parseFloat(metersInput.value) : NaN

        plantsPerMeter = v.plantsPerMeter
        minQuantity = v.minQuantity
        activePrice = v.price
        regularPrice = v.regularPrice
        salePrice = v.salePrice
        currentTiers = Array.isArray(v.pricingTiers) ? v.pricingTiers : []

        metersInput.min = '0'
        metersInput.step = 'any'
        if (qtyInput2) {
            qtyInput2.min = '1'
        }

        if (minQtyValue) {
            minQtyValue.textContent = minQuantity
        }

        hedgeCurrentVariationId = nextId

        // Behåll meter; räkna om qty. Om meter saknas/ogiltigt — fall tillbaka
        // till nya variantens min. Under-min-varningen triggas via syncDisplay
        // om resulterande qty hamnar under nya minimumet.
        if (isNaN(previousMeters) || previousMeters <= 0) {
            const qty = minQuantity
            if (qtyInput2) qtyInput2.value = qty
            metersInput.value = formatDecimal(qty / plantsPerMeter)
            syncDisplay(qty)
        } else {
            const qty = Math.max(1, Math.round(previousMeters * plantsPerMeter))
            metersInput.value = formatDecimal(previousMeters)
            if (qtyInput2) qtyInput2.value = qty
            syncDisplay(qty)
        }
    }

    metersInput.addEventListener('input', onMetersInput)
    metersInput.addEventListener('change', onMetersCommit)

    if (qtyInput2) {
        qtyInput2.addEventListener('input', onQtyInput)
        qtyInput2.addEventListener('change', onQtyCommit)
    }

    calc.querySelector('.hedge-meters-minus')?.addEventListener('click', function (e) {
        e.preventDefault()
        let m = parseFloat(metersInput.value)
        if (isNaN(m)) m = 1
        m = Math.max(1, Math.floor(m) - 1)
        metersInput.value = m
        const qty = Math.max(1, Math.round(m * plantsPerMeter))
        if (qtyInput2) qtyInput2.value = qty
        syncDisplay(qty)
    })

    calc.querySelector('.hedge-meters-plus')?.addEventListener('click', function (e) {
        e.preventDefault()
        let m = parseFloat(metersInput.value)
        if (isNaN(m)) m = 0
        m = Math.floor(m) + 1
        metersInput.value = m
        const qty = Math.max(1, Math.round(m * plantsPerMeter))
        if (qtyInput2) qtyInput2.value = qty
        syncDisplay(qty)
    })

    calc.querySelector('.hedge-qty-minus')?.addEventListener('click', function (e) {
        e.preventDefault()
        let q = parseInt(qtyInput2.value, 10)
        if (isNaN(q)) q = 1
        q = Math.max(1, q - 1)
        qtyInput2.value = q
        metersInput.value = formatDecimal(q / plantsPerMeter)
        syncDisplay(q)
    })

    calc.querySelector('.hedge-qty-plus')?.addEventListener('click', function (e) {
        e.preventDefault()
        let q = parseInt(qtyInput2.value, 10)
        if (isNaN(q)) q = 0
        q = q + 1
        qtyInput2.value = q
        metersInput.value = formatDecimal(q / plantsPerMeter)
        syncDisplay(q)
    })

    // Lyssna på WooCommerce:s jQuery-event för native variationsväxling (select-dropdowns)
    if (variations && typeof jQuery !== 'undefined') {
        jQuery('form.variations_form').on('found_variation', function (e, variation) {
            if (variation && variation.variation_id) {
                window.updateHedgeCalculator(variation.variation_id)
            }
        })
    }

    // Initial körning — säkerställer att starvärdena reflekterar tier-pris om en
    // tier matchar default-kvantiteten redan vid sidladdning.
    syncDisplay(parseInt(qtyInput2 ? qtyInput2.value : minQuantity, 10) || minQuantity)
})

// Leveranstillfälle – uppdatera text vid variantbyte
if (typeof jQuery !== 'undefined') {
    jQuery('form.variations_form').on('found_variation', function (e, variation) {
        const el = document.getElementById('lw-delivery-occasion')
        const wrapper = document.getElementById('lw-delivery-occasion-wrapper')
        if (!el) return
        const text = variation.delivery_occasion || ''
        el.textContent = text
        el.classList.toggle('hidden', !text)
        if (wrapper) wrapper.classList.toggle('hidden', !text)
    })

    jQuery('form.variations_form').on('reset_data', function () {
        const el = document.getElementById('lw-delivery-occasion')
        const wrapper = document.getElementById('lw-delivery-occasion-wrapper')
        if (!el) return
        el.textContent = ''
        el.classList.add('hidden')
        if (wrapper) wrapper.classList.add('hidden')
    })
}
